export const SYNC_HISTORY_TYPES = {
  syncairtableusers: {
    label: 'label.SYNC_HISTORY_AIRTABLE_USERS',
    type: 'USERS'
  },
  syncbamboohrusers: {
    label: 'label.SYNC_HISTORY_BAMBOOHR_USERS',
    type: 'USERS'
  },
  synccalendlyusers: {
    label: 'label.SYNC_HISTORY_CALENDLY_USERS',
    type: 'USERS'
  },
  synccsvusers: {
    label: 'label.SYNC_HISTORY_CSV_USERS',
    type: 'USERS'
  },
  synccustomdirusers: {
    label: 'label.SYNC_HISTORY_CUSTOMDIR_USERS',
    type: 'USERS'
  },
  syncfrontappdirectory: {
    label: 'label.SYNC_HISTORY_FRONTAPP_DIRECTORY',
    type: 'USERS'
  },
  syncgappsgroups: {
    label: 'label.SYNC_HISTORY_GAPPS_GROUPS',
    type: 'GROUPS'
  },
  syncgappsorgs: {
    label: 'label.SYNC_HISTORY_GAPPS_ORGS',
    type: 'ORGANIZATIONS'
  },
  syncgappsusers: {
    label: 'label.SYNC_HISTORY_GAPPS_USERS',
    type: 'USERS'
  },
  syncjumpcloudusers: {
    label: 'label.SYNC_HISTORY_JUMPCLOUD_USERS',
    type: 'USERS'
  },
  synco365groups: {
    label: 'label.SYNC_HISTORY_O365_GROUPS',
    type: 'GROUPS'
  },
  synco365users: {
    label: 'label.SYNC_HISTORY_O365_USERS',
    type: 'USERS'
  },
  syncoktagroups: {
    label: 'label.SYNC_HISTORY_OKTA_GROUPS',
    type: 'GROUPS'
  },
  syncoktausers: {
    label: 'label.SYNC_HISTORY_OKTA_USERS',
    type: 'USERS'
  },
  synconeloginusers: {
    label: 'label.SYNC_HISTORY_ONELOGIN_USERS',
    type: 'USERS'
  },
  syncoutreachdirectory: {
    label: 'label.SYNC_HISTORY_OUTREACH_DIRECTORY',
    type: 'USERS'
  },
  syncmangoappsusers: {
    label: 'label.SYNC_HISTORY_MANGOAPPS_USERS',
    type: 'USERS'
  },
  syncpaylocityusers: {
    label: 'label.SYNC_HISTORY_PAYLOCITY_USERS',
    type: 'USERS'
  },
  syncpingboarddirectory: {
    label: 'label.SYNC_HISTORY_PINGBOARD_DIRECTORY',
    type: 'USERS'
  },
  syncsalesforceusers: {
    label: 'label.SYNC_HISTORY_SALESFORCE_USERS',
    type: 'USERS'
  },
  syncsurefireusers: {
    label: 'label.SYNC_HISTORY_SUREFIRE_USERS',
    type: 'USERS'
  },
  synctotalexpertusers: {
    label: 'label.SYNC_HISTORY_TOTALEXPERT_USERS',
    type: 'USERS'
  }
};
